import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../routes/AppRouterConfig";
import chevronRight from "../../images/icons/chebron_right.svg";

const Breadcrumbs = () => {
  const location = useLocation();
  let pathWords = location.pathname.split("/").filter(Boolean);

  // Для подбора по серии оборудования обрезаем массив до вкладки "Подбор по серии оборудования"
  if (pathWords[0] === "selection" && pathWords[1] === "series") {
    const targetIndex = pathWords.indexOf("series");
    const newPathWords = pathWords.slice(0, targetIndex + 1);
    pathWords = newPathWords;
  }

  const createPathMap = (ROUTES) => {
    const result = {};

    Object.entries(ROUTES).forEach(([_, route]) => {
      const lastPart = route.path.split("/").filter(Boolean).pop() || "";
      if (route.name) result[lastPart] = route.name;
    });

    return result;
  };

  const mapRouting = createPathMap(ROUTES);

  // Проверяем, является ли путь секцией чертежей (documents/drawings/:sectionId)
  const isDrawingsSection =
    pathWords.length >= 3 &&
    pathWords[0] === "documents" &&
    pathWords[1] === "drawings" &&
    pathWords.length === 3;

  // Получаем sectionId для секций чертежей
  const drawingsSectionId = isDrawingsSection ? pathWords[2] : null;

  // Проверяем, является ли путь разделом продуктов
  const isProductsPath = pathWords[0] === "products";
  const isProductsCategory = isProductsPath && pathWords.length === 2;
  const isProductsSeries = isProductsPath && pathWords.length === 3;

  // Получаем данные для продуктов из location.state
  const categoryName =
    isProductsCategory || isProductsSeries
      ? location.state?.categoryName
      : null;
  const seriesName = isProductsSeries ? location.state?.pageTitle : null;

  // Для страницы деталей продукта не показываем последний сегмент, если:
  // - seriesName еще не известен
  // - или seriesName равен categoryName (чтобы избежать дублирования)
  const shouldShowLastSegment =
    !isProductsSeries || (seriesName && seriesName !== categoryName);

  // Для страницы категории продуктов не показываем последний сегмент, если categoryName еще не известен
  const shouldShowCategorySegment = !isProductsCategory || categoryName;

  return (
    pathWords[0] in mapRouting && (
      <div className="breadcrumbs flex-row">
        <Link to={"/"}>{mapRouting[""]}</Link>
        {pathWords.map((word, index, paths) => {
          // Пропускаем последний сегмент для страницы категории продуктов, если categoryName еще не известен
          if (
            isProductsCategory &&
            index === paths.length - 1 &&
            !shouldShowCategorySegment
          ) {
            return null;
          }

          // Пропускаем последний сегмент для страницы деталей продукта, если seriesName еще не известен
          if (index === paths.length - 1 && !shouldShowLastSegment) {
            return null;
          }

          //как бы последний элемент
          if (index === paths.length - 1) {
            // Для секций чертежей отображаем только sectionId (EPP, GPD, DHT)
            let displayText;
            if (isDrawingsSection && drawingsSectionId) {
              displayText = drawingsSectionId;
            } else if (isProductsSeries && seriesName) {
              // Для страницы деталей продукта используем name серии
              displayText = seriesName;
            } else if (isProductsCategory && categoryName) {
              // Для страницы категории продуктов используем название категории
              displayText = categoryName;
            } else {
              displayText = mapRouting[word] || word;
            }

            return (
              <React.Fragment key={index}>
                <div className="chevron-container">
                  <img src={chevronRight} alt="chevron right" />
                </div>
                <Link className="active">{displayText}</Link>
              </React.Fragment>
            );
          } else {
            // Для промежуточных элементов
            // Для страницы деталей продукта не показываем промежуточный сегмент (categoryId), если categoryName еще не известен
            if (isProductsSeries && index === 1 && !categoryName) {
              return null;
            }

            let displayText;
            // Если это раздел продуктов и это промежуточный элемент (categoryId)
            if (isProductsSeries && index === 1 && categoryName) {
              // Используем название категории из location.state.categoryName
              displayText = categoryName;
            } else {
              displayText = mapRouting[word] || word;
            }

            return (
              <React.Fragment key={index}>
                <div className="chevron-container">
                  <img src={chevronRight} alt="chevron right" />
                </div>
                <Link to={"/" + paths.slice(0, index + 1).join("/")}>
                  {displayText}
                </Link>
              </React.Fragment>
            );
          }
        })}
      </div>
    )
  );
};

export default Breadcrumbs;
